export default function ProgressRing({ size = 60, pct = 0, color = '#C8784E', strokeWidth = 8, gradientId = 'ring' }) {
  const r = (size / 2) - strokeWidth
  const C = 2 * Math.PI * r
  const clampedPct = Math.min(100, Math.max(0, pct))
  const offset = C - (clampedPct / 100) * C
  const gId = `grad-${gradientId}`

  return (
    <svg width={size} height={size} style={{ transform: 'rotate(-90deg)', flexShrink: 0 }}>
      <defs>
        <linearGradient id={gId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={color} stopOpacity="0.6" />
          <stop offset="100%" stopColor={color} />
        </linearGradient>
      </defs>
      <circle
        cx={size / 2} cy={size / 2} r={r}
        fill="none" stroke={color} strokeOpacity="0.12"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2} cy={size / 2} r={r}
        fill="none" stroke={`url(#${gId})`}
        strokeWidth={strokeWidth}
        strokeDasharray={C}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
    </svg>
  )
}
